export function isLight(color = [100, 100, 100, 1]) {
  let C = color.map((val) => val / 255)

  for (let i = 0; i < C.length; i++) {
    if (C[i] <= 0.03928) C[i] = C[i] / 12.92
    else C[i] = Math.pow((C[i] + 0.055) / 1.055, 2.4)
  }

  const L = 0.2126 * C[0] + 0.7152 * C[1] + 0.0722 * C[2]
  return L > 0.35 // originally 0.179`
}

export function isDark(color) {
  return !isLight(color)
}

export function colourStringToRgbaParts(str) {
  if (str.match(/^#/)) {
    const values = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(str)
    const rgbValues = [values[1], values[2], values[3]].map((val) => parseInt(val, 16))
    return [...rgbValues, 1]
  } else if (str.match(/^rgba?\(/)) {
    const values = str.replace(/[^\d,.]/g, '').split(',')
    return values.length === 3 ? [...values, 1] : values
  } else {
    console.log('oof')
    return [0, 0, 0, 1]
  }
}
